import React, { useState, useEffect } from "react";
import axios from "axios";
// import Navbar from './../NavBar';
import CustomNavbar from "../CustomPermissions/CustomNavbar";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import DOMPurify from "dompurify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import SummaryCell from "./SummaryCell";

import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../../config/api";

const AllMinutesOfMeeting = (props) => {
  const [MinutesOfMeeting, setMinutesOfMeeting] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [totalMOM, setTotalMOM] = useState(0);

  const [editData, setEditData] = useState({
    id: "",
    title: "",
    momdate: "",
    summary: "",
  });
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [viewSummary, setViewSummary] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const location = useLocation();
  const additionalData = location.state?.userPermissions || props.dataProp;

  useEffect(() => {
    const fetchMinutesOfMeeting = async () => {
      try {
        const response = await axios.get(
          getApiUrl("/api/moms/"),
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        setMinutesOfMeeting(response.data);
        setTotalMOM(response.data.length);
      } catch (error) {
        console.error("Error fetching MinutesOfMeeting:", error);
      }
    };

    fetchMinutesOfMeeting();
  }, []);

  const formatDateTime = (datetimeString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(datetimeString).toLocaleString(undefined, options);
  };

  // Filter MOMs based on search term
  const filteredMOMs = MinutesOfMeeting.filter((mom) => {
    const searchLower = searchTerm.toLowerCase();
    const titleMatch = mom.title ? mom.title.toLowerCase().includes(searchLower) : false;
    const dateMatch = mom.momdate ? formatDateTime(mom.momdate).toLowerCase().includes(searchLower) : false;
    // Strip HTML from summary for searching
    const summaryText = mom.summary ? mom.summary.replace(/<[^>]*>?/gm, '').toLowerCase() : '';
    const summaryMatch = summaryText.includes(searchLower);

    return titleMatch || dateMatch || summaryMatch;
  });

  const handleDelete = async (id) => {
    try {
      const userConfirmed = window.confirm("Are you sure you want to delete?");
      if (userConfirmed) {
        await axios.delete(getApiUrl(`/api/moms/${id}/`), {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        });
        setMinutesOfMeeting((prevMinutesOfMeeting) =>
          prevMinutesOfMeeting.filter((MoM) => MoM.id !== id)
        );
      }
    } catch (error) {
      console.error("Error deleting MoM:", error);
    }
  };

  const handleEditClick = (MoM) => {
    setEditData(MoM);
    setIsEditModalOpen(true);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleEditSave = async () => {
    try {
      const response = await axios.put(
        getApiUrl(`/api/moms/${editData.id}/`),
        editData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setMinutesOfMeeting((prevState) =>
        prevState.map((mom) => (mom.id === editData.id ? response.data : mom))
      );
      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Error updating MoM:", error);
    }
  };

  const createMarkup = (html) => {
    return { __html: DOMPurify.sanitize(html) };
  };

  const handleViewClick = (summary) => {
    setViewSummary(summary);
    setIsViewModalOpen(true);
  };

  const renderEditModal = () => (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <h2 style={modalTitleStyle} className="text-blue-500">Edit Minutes of Meeting</h2>

        <form style={formStyle}>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Title</label>
            <input
              type="text"
              name="title"
              value={editData.title}
              onChange={handleEditChange}
              style={inputStyle}
            />
          </div>
          <div style={formGroupStyle}>
            <label style={labelStyle}>MoM Date</label>
            <input
              type="date"
              name="momdate"
              value={editData.momdate}
              onChange={handleEditChange}
              style={inputStyle}
            />
          </div>
          <div style={formGroupStyle}>
            <label style={labelStyle}>Summary</label>
            <CKEditor
              editor={ClassicEditor}
              data={editData.summary}
              onChange={(event, editor) => {
                const data = editor.getData();
                setEditData((prevState) => ({
                  ...prevState,
                  summary: data,
                }));
              }}
            />
          </div>
          <div style={buttonGroupStyle}>
            <button
              type="button"
              onClick={() => setIsEditModalOpen(false)}
              style={cancelButtonStyle}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleEditSave}
              style={saveButtonStyle}
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  const renderViewModal = () => (
    <div style={modalOverlayStyle}>
      <div style={modalContentStyle}>
        <div
          className="mb-3"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h2 style={modalTitleStyle} className="text-blue-500">View Summary</h2>

        </div>
        <div
          className="border p-2"
          style={viewSummaryStyle}
          dangerouslySetInnerHTML={createMarkup(viewSummary)}
        ></div>
        <div style={buttonGroupStyle}>
          <button
            type="button"
            onClick={() => setIsViewModalOpen(false)}
            style={closeButtonStyle}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div style={{ display: "flex" }}>
        {additionalData === "custom_operation" ? (
          <>
            <CustomNavbar dataProp="custom_operation" />
          </>
        ) : (
          <>
            <CustomNavbar dataProp="tlandbh" />
          </>
        )}

        <div style={{ width: "98%", margin: "15px auto" }}>
          {isEditModalOpen && renderEditModal()}
          {isViewModalOpen && renderViewModal()}
          <div
            className="container mt-3 mb-2"
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            <h1 className="text-center text-5xl text-blue-700 mb-2">MOMs</h1>
            <a
              href="/createmom"
              className="bg-blue-500 text-white px-4 py-2 mb-2 rounded hover:bg-blue-900 transition-colors"
            >
              Add New File
            </a>
          </div>

          {/* Search Bar */}
          <div className="w-full flex justify-center mb-6">
            <div className="relative w-full max-w-lg">

              {/* Search Icon */}
              <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                <svg
                  className="h-5 w-5 text-gray-400"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </div>

              {/* Input */}
              <input
                type="text"
                placeholder="Search meetings..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="
        w-full 
        pl-12 pr-10 
        py-3 
        border 
        border-gray-300 
        rounded-full 
        shadow-sm 
        bg-white
        text-sm
        focus:outline-none 
        focus:ring-2 
        focus:ring-blue-500 
        focus:border-blue-500
        transition-all
        duration-200
      "
              />

              {/* Clear Button */}
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  className="absolute inset-y-0 right-0 flex items-center pr-4 text-gray-400 hover:text-gray-600 transition"
                >
                  ✕
                </button>
              )}
            </div>
          </div>
          <table
            className="min-w-full bg-white"
            style={{ width: "90%", margin: "auto" }}
          >
            <thead>
              <tr>
                <th colSpan="4" className="bg-white text-dark text-xl">Total: {totalMOM}</th>
              </tr>
              <tr className="bg-blue-500">
                <th scope="col" className="py-2 px-4 border-b">
                  MoM
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  MoM Date
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Summary
                </th>
                <th scope="col" className="py-2 px-4 border-b">
                  Options
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300 text-center">
              {filteredMOMs.length === 0 ? (
                <tr>
                  <td colSpan="4" className="py-8 text-gray-600">
                    {searchTerm ? `No MOMs found matching "${searchTerm}"` : 'No Minutes of Meeting found.'}
                  </td>
                </tr>
              ) : (
                filteredMOMs.map((MoM) => (
                  <tr key={MoM.id} style={{ fontSize: "14px", border: "1px solid #E5E7EB" }}>
                    <td className="py-2 px-4 border-b">{MoM.title}</td>
                    <td className="py-2 px-4 border-b">
                      {formatDateTime(MoM.momdate)}
                    </td>
                    <SummaryCell summary={MoM.summary} />
                    <td className="py-3 px-4 flex">
                      <button
                        className="bg-yellow-300 px-3 py-2 rounded text-white m-1"
                        onClick={() => handleEditClick(MoM)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-pen"
                          viewBox="0 0 16 16"
                        >
                          <path d="m13.498.795.149-.149a1.207 1.207 0 1 1 1.707 1.708l-.149.148a1.5 1.5 0 0 1-.059 2.059L4.854 14.854a.5.5 0 0 1-.233.131l-4 1a.5.5 0 0 1-.606-.606l1-4a.5.5 0 0 1 .131-.232l9.642-9.642a.5.5 0 0 0-.642.056L6.854 4.854a.5.5 0 1 1-.708-.708L9.44.854A1.5 1.5 0 0 1 11.5.796a1.5 1.5 0 0 1 1.998-.001m-.644.766a.5.5 0 0 0-.707 0L1.95 11.756l-.764 3.057 3.057-.764L14.44 3.854a.5.5 0 0 0 0-.708z" />
                        </svg>
                      </button>
                      <button
                        className="bg-red-500 px-3 py-2 rounded text-white m-1"
                        onClick={() => handleDelete(MoM.id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-trash3"
                          viewBox="0 0 16 16"
                        >
                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                        </svg>
                      </button>
                      <Link
                        to={`/mom/${MoM.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-blue-500 px-3 py-2 rounded text-white m-1 inline-flex items-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-eye"
                          viewBox="0 0 16 16"
                        >
                          <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8M1.173 8a13 13 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5s3.879 1.168 5.168 2.457A13 13 0 0 1 14.828 8q-.086.13-.195.288c-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5s-3.879-1.168-5.168-2.457A13 13 0 0 1 1.172 8z" />
                          <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0" />
                        </svg>
                      </Link>
                    </td>
                  </tr>
                ))
              )}

            </tbody>
            {/* <Link to="/createmom">
              <button className="fixed bottom-5 left-8 bg-blue-700 text-white p-4 rounded-full">
                +
              </button>
            </Link> */}
          </table>
        </div>
      </div>
    </>
  );
};

const modalOverlayStyle = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.7)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
  overflow: "auto",
};

const modalContentStyle = {
  backgroundColor: "white",
  padding: "1.5rem",
  borderRadius: "0.5rem",
  boxShadow: "0 0 10px rgba(0, 0, 0, 0.25)",
  maxWidth: "80%",
  maxHeight: "80%",
  overflowY: "auto",
};

const modalTitleStyle = {
  fontSize: "1.25rem",
  marginBottom: "1rem",
};

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
};

const formGroupStyle = {
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
};

const labelStyle = {
  fontWeight: "bold",
  color: "#333",
};

const inputStyle = {
  padding: "0.5rem",
  border: "1px solid #ccc",
  borderRadius: "0.25rem",
};

const buttonGroupStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "0.5rem",
};

const cancelButtonStyle = {
  padding: "0.5rem 1rem",
  backgroundColor: "#555",
  color: "white",
  borderRadius: "0.25rem",
  cursor: "pointer",
};

const saveButtonStyle = {
  padding: "0.5rem 1rem",
  backgroundColor: "#007bff",
  color: "white",
  borderRadius: "0.25rem",
  cursor: "pointer",
};

const closeButtonStyle = {
  padding: "0.5rem 1rem",
  backgroundColor: "#007bff",
  color: "white",
  borderRadius: "0.25rem",
  cursor: "pointer",
};

const viewSummaryStyle = {
  marginBottom: "1rem",
  maxHeight: "400px",
  overflowY: "auto",
};

export default AllMinutesOfMeeting;
